import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { giphyBlack, giphyCharcoal } from '@giphy/js-brand'
import { useContext, useState } from 'react'
import LayerOptions from '../../../components/layer-actions'
import { UgeEditorContext } from '../../../contexts/editor'
import { Layer } from '../../../types'
import Header from './header'
import { Collapse, Container, DragButton } from './style'

type Props = {
    className?: string
    dragDisabled?: boolean
    layer: Layer
}

const LayersEditorLayer = ({ className, dragDisabled = false, layer }: Props) => {
    const { activeEditorProps, resetEditorProps } = useContext(UgeEditorContext)
    const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({ id: layer.id })
    const [isLayerOpen, setIsLayerOpen] = useState<boolean>(false)
    const isLayerActive = layer.id === activeEditorProps?.layerId

    const dragStyle = {
        transform: CSS.Translate.toString(transform),
        transition,
    }

    const onCollapseChange = (isOpen: boolean) => {
        if (isLayerActive && !isOpen) {
            resetEditorProps()
        } else if (!isLayerActive) {
            setIsLayerOpen(isOpen)
        }
    }

    return (
        <Container className={className} dragging={isDragging} style={dragStyle}>
            <Collapse
                buttonOptions={{ color: '#111' }}
                label={
                    <Header
                        gradient={isDragging || isLayerOpen || isLayerActive ? 'indigo-blue' : undefined}
                        layer={layer}
                    />
                }
                open={isLayerOpen || isLayerActive}
                size="medium"
                onChange={onCollapseChange}
            >
                <LayerOptions layer={layer} />
            </Collapse>
            {!dragDisabled && (
                <DragButton
                    {...listeners}
                    {...attributes}
                    color={giphyBlack}
                    icon="dragger"
                    iconColor={giphyCharcoal}
                    ref={setNodeRef}
                    size="small"
                />
            )}
        </Container>
    )
}

export default LayersEditorLayer
